import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
import { Quote } from 'lucide-react';
const testimonials = [{
  name: 'Martín L.',
  city: 'CABA',
  quote: 'Vapeaba hace 4 años y probé de todo. Este método fue lo único que me funcionó. Llevo 2 meses sin tocar el vape.'
}, {
  name: 'Camila R.',
  city: 'Córdoba',
  quote: 'Lo mejor es que no sentí que estaba sufriendo. El plan te lleva paso a paso y cuando te das cuenta, ya no lo necesitás.'
}, {
  name: 'Lucas M.',
  city: 'Rosario',
  quote: 'Pensé que era chamuyo pero le di una chance. Mejor decisión del año. Ahorro $60.000 por mes.'
}];
export function ObjectionsSection() {
  return <section className="py-6 md:py-24 px-4 bg-gray-50 border-y border-gray-200" data-id="element-101">
      <div className="max-w-5xl mx-auto" data-id="element-102">
        <FadeIn data-id="element-103">
          <div className="text-center mb-8 md:mb-16" data-id="element-104">
            <h2 className="font-display font-black text-3xl md:text-5xl text-gray-900" data-id="element-105">
              Lo que pasa cuando aplicás el método.
            </h2>
          </div>
        </FadeIn>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-106">
          {testimonials.map((testimonial, idx) => <StaggerItem key={idx} className="bg-white p-6 md:p-8 rounded-2xl border border-gray-200 shadow-sm relative flex flex-col" data-id="element-107">
              <Quote className="text-celeste/20 absolute top-4 right-4" size={48} data-id="element-108" />
              <p className="text-gray-700 text-lg md:text-xl italic mb-6 relative z-10 flex-grow" data-id="element-109">
                "{testimonial.quote}"
              </p>
              <div className="mt-auto" data-id="element-110">
                <p className="font-display font-bold text-gray-900 text-lg" data-id="element-111">
                  {testimonial.name}
                </p>
                <p className="text-celeste font-medium text-sm" data-id="element-112">
                  {testimonial.city}
                </p>
              </div>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}